import React, { useEffect, useState } from 'react';
import * as Compat from '../Compat';
import * as Dati from '../Dati';
import { Trad, BottoneAPI } from './';
import { Metodi } from '../ChiamaWeb';

export class CambioStatoBottoniProps {
    Stati: Dati.TDictTipo = {};
    StatoCorrente: string = "";
    IgnoraPermessi?: boolean = false;
    Traduci?: boolean = true;
    URL: string = "";
    Metodo?: Metodi = "GET";
    OnInvio: (sender: BottoneAPI, nuovoStato: string) => any;
    OnClick?: (sender: BottoneAPI, dati: any) => void;
    OnErrore?: (sender: BottoneAPI, errore: Error) => void;
}

export const CambioStatoBottoni: React.FC<CambioStatoBottoniProps> = (props) => {
    let [ListaBottoni, setListaBottoni] = useState<React.ReactNodeArray>([]);

    function TraduciDati(dati: Dati.CTipo[], traduci: boolean): Dati.CTipo[] {
        let D: Dati.CTipo[] = [];
        for (let dato in dati) {
            let TrovaPermessoPartenza = -1
            if (dati[dato].Permesso != null) {
                if (dati[dato].Permesso != undefined) {
                    TrovaPermessoPartenza = (dati[dato].Permesso || []).indexOf(props.StatoCorrente);
                }
            }
            if (props.IgnoraPermessi                                                               //Richiesto di ignorare i permessi
                || dati[dato].Permesso == undefined || dati[dato].Permesso == null                 //Permesso non è gestito
                || TrovaPermessoPartenza >= 0                                                      //Permesso è gestito e lo stato di arrivo è collegato allo stato di partenza selezionato
                || (TrovaPermessoPartenza == -1 && dati[dato].ID_Chiave == props.StatoCorrente)) { //Permesso è gestito, non attivato, ma la chiave e quella selezionata
                let ID = D.push(Compat.ES6_Object_assign(dati[dato])) - 1;
                if (traduci) {
                    if (D[ID].Parametri != null) {
                        D[ID].Valore = Trad.TradParam(D[ID].Valore, D[ID].Parametri);
                    } else {
                        D[ID].Valore = Trad.Trad(D[ID].Valore);
                    }
                }
            }
        }

        return D;
    }

    function DictTipoToAny(dati: Dati.TDictTipo): any[] {
        let Valori: any[] = [];
        for (let C in dati) {
            Valori.push({
                ID_Chiave: dati[C].ID_Chiave, Valore: dati[C].Valore, Permesso: dati[C].Permesso
            });
        }
        return Valori;
    }

    useEffect(() => {
        let StatiDaVisualizzare = TraduciDati(DictTipoToAny(props.Stati), props.Traduci || true);

        setListaBottoni([]);
        ListaBottoni = []; //setListaBottoni viene eseguito in maniera asincrona da React
        for (let S = 0; S < StatiDaVisualizzare.length; S++) {
            if (StatiDaVisualizzare[S].ID_Chiave != props.StatoCorrente) {
                setListaBottoni(ListaBottoni.concat(
                    <BottoneAPI
                        key={StatiDaVisualizzare[S].ID_Chiave}
                        URL={props.URL}
                        Metodo={props.Metodo}
                        Testo={Trad.Trad("Passa a: ") + StatiDaVisualizzare[S].Valore}
                        OnInvio={(s) => props.OnInvio(s, StatiDaVisualizzare[S].ID_Chiave)}
                        OnClick={(s, d) => {
                            if (props.OnClick != null) {
                                props.OnClick(s, d);
                            }
                        }}
                        OnErrore={(s, e) => {
                            if (props.OnErrore != null) {
                                props.OnErrore(s, e);
                            }
                        }}
                    />
                ));
            }
        }
    }, [props.Stati, props.StatoCorrente]);

    return <>{ListaBottoni}</>;
}



// WEBPACK FOOTER //
// ./src/components/CambioStatoBottoni.tsx